import React from 'react';
import { getRpmDeviceTypeLabel } from '../../constants/other';
import { resolveRpmThresholdChartAlerts } from '../../utils/rpmAlertQueueUtils';
import RpmThresholdChartAlertCard from './RpmThresholdChartAlertCard';

class RpmThresholdChartAlertsPanel extends React.Component {
    constructor(props) {
        super(props);
        this.initialExpandDone = false;
        this.state = {
            expandedIds: {},
        };
    }

    componentDidMount() {
        this.applyInitialExpand();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.todoLists !== this.props.todoLists) {
            this.applyInitialExpand();
        }
    }

    applyInitialExpand() {
        const alerts = resolveRpmThresholdChartAlerts(this.props.todoLists);
        if (!alerts.length || this.initialExpandDone) {
            return;
        }
        const first = alerts[0];
        const todoId = first.todo_id || first.id;
        this.initialExpandDone = true;
        this.setState({
            expandedIds: { [todoId]: true },
        });
    }

    toggleExpand = (todoId) => {
        this.setState(({ expandedIds }) => ({
            expandedIds: {
                ...expandedIds,
                [todoId]: !expandedIds[todoId],
            },
        }));
    };

    resolveDeviceLabel() {
        const { chartContext, patient, rpmDeviceTypes, patientId } = this.props;
        const pid = patientId != null ? Number(patientId) : null;
        let deviceTypeId = patient && patient.rpm_device_type_id;
        if (chartContext && pid != null && Number(chartContext.patientId) === pid) {
            deviceTypeId = chartContext.rpm_device_type_id != null
                ? chartContext.rpm_device_type_id
                : deviceTypeId;
        }
        return getRpmDeviceTypeLabel(rpmDeviceTypes, deviceTypeId) || 'RPM Monitoring';
    }

    render() {
        const {
            todoLists,
            urgentTypes,
            onComplete,
            completingTodoId,
        } = this.props;
        const alerts = resolveRpmThresholdChartAlerts(todoLists);
        if (!alerts.length) {
            return null;
        }

        const deviceLabel = this.resolveDeviceLabel();
        const countLabel = alerts.length === 1
            ? '1 RPM Threshold Alert'
            : `${alerts.length} RPM Threshold Alerts`;

        return (
            <div className="rpm-chart-alerts-panel">
                <div className="rpm-chart-alerts-panel__header">
                    <span className="rpm-chart-alerts-panel__title">{countLabel}</span>
                    <span className="rpm-chart-alerts-panel__device-pill">{deviceLabel}</span>
                </div>
                <div className="rpm-chart-alerts-panel__list">
                    {alerts.map((alert) => {
                        const todoId = alert.todo_id || alert.id;
                        return (
                            <RpmThresholdChartAlertCard
                                key={todoId}
                                alert={alert}
                                urgentTypes={urgentTypes}
                                expanded={!!this.state.expandedIds[todoId]}
                                onToggleExpand={this.toggleExpand}
                                onComplete={onComplete}
                                completingTodoId={completingTodoId}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default RpmThresholdChartAlertsPanel;
